import React from 'react'
import classNames from 'classnames/bind'

import { Modal } from '@percent/lemonade'
import styles from './Dialog.module.scss'
import { DialogProps } from './Dialog.types'
import { DialogHeader } from './DialogHeader'

const cx = classNames.bind(styles)

export function Dialog({ openModal, onClose, headerTitle, children, fullscreen, withoutHeader = false }: DialogProps) {
  return (
    <Modal
      open={openModal}
      onClose={onClose}
      fullScreen={fullscreen}
      isFullscreen={fullscreen}
      className={cx('dialog')}
    >
      {!withoutHeader && <DialogHeader onClose={onClose} headerTitle={headerTitle} />}
      {children}
    </Modal>
  )
}
